export default __webpack_public_path__ + "static/media/Start-Button-Logo_02.906d0c1e.png";